import { createContext } from 'react';

import type { ConfigFiltersContextType } from './types';

export const AppConfigFiltersContext =
  createContext<ConfigFiltersContextType>(null);
